var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-table-header-sorting",class:{
    'm-table-header-sorting_asc': _vm.sortDirection === 'asc',
    'm-table-header-sorting_desc': _vm.sortDirection === 'desc',
    'm-table-header-sorting_disabled': _vm.disabled
  }},[_c('MIcon',{staticClass:"m-table-header-sorting__icon m-table-header-sorting__asc-icon",attrs:{"icon":_vm.bulletArrowIcon}}),_vm._v(" "),_c('MIcon',{staticClass:"m-table-header-sorting__icon m-table-header-sorting__desc-icon",attrs:{"icon":_vm.bulletArrowIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }